import React, { useState } from "react";
import { Form, Input } from "semantic-ui-react";
import { Box, Button, CircularProgress, Typography, Alert } from "@mui/material";
import { Link } from "react-router-dom";
import PageTitle from "../../components/PageTitle/PageTitle";
import customHttp from "../../services/customHTTP";
import { useAuth } from "../../context/authContext";
import "./Login.css";
import AuthedUser from "../AuthedUser/AuthedUser";
import { ASSETS_BASE_URL } from "../../config";

const Login = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(""); // General error message
	const [emailError, setEmailError] = useState(""); // Email-specific error
	const [passwordError, setPasswordError] = useState(""); // Password-specific error
	const [loading, setLoading] = useState(false);
	const { login, isAuthenticated } = useAuth(); // Access the login function from AuthContext
	const AuthPageStyles = {
		backgroundImage: `url('${ASSETS_BASE_URL}/home_bg2.jpg')`,
		backgroundSize: "cover",
		backgroundPosition: "center",
	};
	const handleLogin = async (e) => {
		e.preventDefault();
		setError("");
		setEmailError("");
		setPasswordError("");
		setLoading(true);

		let valid = true;

		if (!email) {
			setEmailError("Email is required");
			valid = false;
		}

		if (!password) {
			setPasswordError("Password is required");
			valid = false;
		}

		if (!valid) {
			setLoading(false);
			return;
		}

		try {
			const response = await customHttp.post("/auth/login", {
				user_email: email,
				user_password: password,
			});

			const { token, user, user_meta_data } = response.data;
			if (token && user) {
				login(token, user, user_meta_data);
				// setLoggedinUser(user);
				// handleLoginCart(user);
			} else {
				setError("Login failed: Invalid response received");
			}
		} catch (error) {
			if (error.response?.status === 400 || error.response?.status === 500) {
				setError(error.response?.data?.message || "An error occurred. Please try again later.");
			} else {
				setError("An unexpected error occurred.");
			}
		}

		setLoading(false);
	};

	const combinedErrorMessage = [emailError, passwordError, error].filter(Boolean).join(" | ");

	if (isAuthenticated) {
		return <AuthedUser />;
	}

	return (
		<Box className="login-container" sx={AuthPageStyles}>
			<Box className="login-form-container">
				<img src="/logo.png" alt="Logo" className="login-logo" />
				<div className="form-container">
					<PageTitle title="Login" />

					{combinedErrorMessage && (
						<Alert severity="error" sx={{ width: "100%", marginBottom: "0", marginTop: "15px" }}>
							{combinedErrorMessage}
						</Alert>
					)}
					<Form className="login-form" onSubmit={handleLogin} error={!!combinedErrorMessage}>
						<Form.Field error={!!emailError}>
							<Input
								fluid
								placeholder="Username or Email"
								type="email"
								className="login-input"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
						</Form.Field>
						<Form.Field error={!!passwordError}>
							<Input
								fluid
								placeholder="Password"
								type="password"
								className="login-input"
								value={password}
								onChange={(e) => setPassword(e.target.value)}
							/>
						</Form.Field>
						<Box className="login-links">
							<Link to="/forgot-password" className="login-link">
								Forgot Password?
							</Link>
						</Box>
						<div className="login-button">
							<Button
								variant="contained"
								color="primary"
								className="button-primary"
								type="submit"
								sx={{ minWidth: "120px" }}
								disabled={loading}>
								{loading ? "Logging in..." : "Login"}
							</Button>
						</div>
					</Form>
					{loading && (
						<Box display="flex" alignItems="center" justifyContent="center" mt={2}>
							<CircularProgress size={24} sx={{ color: "green" }} />
							<Typography variant="body2" sx={{ marginLeft: 2, color: "green" }}>
								Verifying...
							</Typography>
						</Box>
					)}
				</div>
				<Link to="/register" className="login-link">
					Request for New Account
				</Link>
			</Box>
		</Box>
	);
};

export default Login;
